import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import fObjectSelectorDrawer from '@/components/fObjectSelectorDrawer';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import { useGetState } from '@/utils/hooks';
import fMessage from '@/components/fMessage';
import fOccupiedFileResourceVersion from '@/components/fOccupiedFileResourceVersion';
import FIcons from '@/components/FIcons';

interface FStorageSpaceProps {
  style?: React.CSSProperties;
  resourceTypeCode: string;

  onSucceed?(value: {
    bucketID: string;
    bucketName: string;
    sha1: string;
    objectID: string;
    objectName: string;
  }): void;
}

interface FStorageSpaceStates {
  $objectInfo: {
    bucketID: string;
    bucketName: string;
    sha1: string;
    objectID: string;
    objectName: string;
  } | null;
}

const initStates: FStorageSpaceStates = {
  $objectInfo: null,
};

function FStorageSpace({ style = {}, resourceTypeCode, onSucceed }: FStorageSpaceProps) {
  const [$objectInfo, set$objectInfo, get$objectInfo] = useGetState<
    FStorageSpaceStates['$objectInfo']
  >(initStates['$objectInfo']);

  return (
    <>
      <div className={styles.storageSpace} style={style}>
        <FIcons.FStorageSpace style={{ fontSize: 60 }} />
        <div style={{ height: 40 }} />
        <FComponentsLib.FContentText
          text={
            // '选择存储空间对象作为发行对象'
            FI18n.i18nNext.tAuto('rqr_input_object_fromstorage_help')
          }
          type={'additional2'}
        />
        <div style={{ height: 40 }} />
        <FComponentsLib.FRectBtn
          type={'primary'}
          onClick={async () => {
            const obj = await fObjectSelectorDrawer({
              resourceTypeCode: resourceTypeCode,
            });
            if (!obj) {
              return;
            }

            set$objectInfo({
              bucketID: obj.bucketID,
              bucketName: obj.bucketName,
              sha1: obj.sha1,
              objectID: obj.objID,
              objectName: obj.objName,
            });

            const params3: Parameters<typeof FServiceAPI.Resource.getResourceBySha1>[0] = {
              fileSha1: obj.sha1,
            };

            const { data: data_ResourcesBySha1 } = await FServiceAPI.Resource.getResourceBySha1(
              params3,
            );

            if (data_ResourcesBySha1.length > 0) {
              if (data_ResourcesBySha1[0].userId === FUtil.Tool.getUserIDByCookies()) {
                const usedResources = data_ResourcesBySha1
                  .map((d: any) => {
                    return d.resourceVersions.map((v: any) => {
                      return {
                        resourceID: d.resourceId,
                        resourceName: d.resourceName,
                        resourceType: d.resourceType,
                        resourceVersion: v.version,
                        cover: d.coverImages?.[0] || '',
                        username: d.username,
                        userAvatar: FUtil.Tool.getAvatarUrl(d.userId),
                        url: FUtil.LinkTo.resourceVersionInfo({
                          resourceID: d.resourceId,
                          version: v.version,
                        }),
                      };
                    });
                  })
                  .flat();

                const next = await fOccupiedFileResourceVersion({
                  list: usedResources,
                  canOk: true,
                });

                if (next) {
                  const fileInfo = get$objectInfo();
                  if (fileInfo) {
                    onSucceed && onSucceed(fileInfo);
                  }
                }
              } else {
                const usedResources = data_ResourcesBySha1
                  .map((d: any) => {
                    return d.resourceVersions.map((v: any) => {
                      return {
                        resourceID: d.resourceId,
                        resourceName: d.resourceName,
                        resourceType: d.resourceType,
                        resourceVersion: v.version,
                        cover: d.coverImages?.[0] || '',
                        username: d.username,
                        userAvatar: FUtil.Tool.getAvatarUrl(d.userId),
                        url: FUtil.LinkTo.resourceDetails({
                          resourceID: d.resourceId,
                          version: v.version,
                        }),
                      };
                    });
                  })
                  .flat();
                await fOccupiedFileResourceVersion({
                  list: usedResources,
                  canOk: false,
                });
              }
            } else {
              const objectInfo = get$objectInfo();
              if (objectInfo) {
                onSucceed && onSucceed(objectInfo);
              } else {
                fMessage('导入失败', 'error');
              }
            }
          }}
        >
          {
            // 存储空间导入
            FI18n.i18nNext.tAuto('rqr_btn_object_fromstorage')
          }
        </FComponentsLib.FRectBtn>
      </div>
    </>
  );
}

export default FStorageSpace;
